export default [
  {
    title: 'مدیریت محصول‌ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'محصول‌ها',
        route: { name: 'product' },
        resource: 'ProductManager',
        action: 'show',
      },
      {
        title: 'نظرها',
        route: { name: 'productcomment' },
        resource: 'ProductCommentManager',
        action: 'show',
        // disabled: true,
      },
      {
        title: 'دسته‌بندی‌ها',
        route: { name: 'productcategory' },
        resource: 'ProductCategoryManager',
        action: 'show',
      },
      {
        title: 'برندها',
        route: { name: 'brand' },
        resource: 'BrandManager',
        action: 'show',
      },
      {
        title: 'گارانتی‌ها',
        route: { name: 'guaranty' },
        resource: 'GuarantyManager',
        action: 'show',
      },
      {
        title: 'برندهای گوشی',
        route: { name: 'phonebrand' },
        resource: 'PhoneBrandManager',
        action: 'show',
      },
      {
        title: 'مدل های گوشی',
        route: { name: 'phonemodel' },
        resource: 'PhoneModelManager',
        action: 'show',
      },
      // {
      //   title: 'رنگ‌ها',
      //   route: { name: 'color' },
      //   resource: 'ColorManager',
      //   action: 'show',
      // },
      // {
      //   title: 'سایزها',
      //   // route: { name: 'brand' },
      //   resource: 'BrandManager',
      //   action: 'show',
      //   disabled: true,
      // },
      {
        title: 'تامین‌کننده‌ها',
        route: { name: 'supplier' },
        resource: 'SupplierManager',
        action: 'show',
      },
      {
        title: 'متریال‌ها',
        route: { name: 'material' },
        resource: 'MaterialManager',
        action: 'show',
      },
    ],
  },
]
